import cs from './cs.json';
import de from './de.json';
import en from './en.json';

export default {
  cs,
  de,
  en,
};
